import React from 'react';
import Header from '../Components/Header';
import Mail from '../Components/Mail';
import Social from '../Components/Social';
import About from '../Components/About';
import Projects from '../Components/Projects';
import Skills from '../Components/Skills';
import Experience from '../Components/Experience';
import Clients from '../Components/Clients';
import Contact from '../Components/Contact';
import Footer from '../Components/Footer';
import { Loader } from '../Components/Loader';
import { Toaster } from 'react-hot-toast';
import Acheivement from '../Components/Acheivements';
import ResumeViewer from '../Components/ResumeViewer';

interface HomepageProps {
  showResumeModal?: boolean; // Define prop type
}

const Homepage: React.FC<HomepageProps> = ({ showResumeModal = false }) => {
  const [loading, setLoading] = React.useState(true);
  const [resumeOpened, setResumeOpened] = React.useState(showResumeModal); // Set the modal state

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  React.useEffect(() => {
    setResumeOpened(showResumeModal); // Trigger modal based on prop
  }, [showResumeModal]); // Add showResumeModal as dependency

  return (
    <div className={`focus-visible:[&_button]:!outline-none min-h-[100dvh] ${loading ? "flex" : ""} items-center overflow-hidden justify-center`}>
      {loading !== true ? (
        <>
          <Toaster />
          <Header />
          <About />
          <Projects />
          <Clients />
          <Skills />
          <Experience />
          <Acheivement />
          <Contact />
          <Footer />
          <Mail />
          <Social />
          <ResumeViewer opened={resumeOpened} close={() => setResumeOpened(false)} /> {/* Resume modal */}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default Homepage;
